// extracted by mini-css-extract-plugin
export default {"layout":"ChangePasswordPopup__layout--RUQ","container":"ChangePasswordPopup__container--CHI"};